/** The tool shown on the rental Správa page (`/pujcovna/sprava?nastroj=…`); pobočky is the default. */
export type SpravaNastroj = 'pobocky' | 'tarify' | 'pojistovny' | 'brana' | 'vyjimky' | 'nastaveni' | 'historie';

export interface PujcovnaSpravaSearch {
  nastroj?: SpravaNastroj;
}

export function parsePujcovnaSpravaSearch(input: Record<string, unknown>): PujcovnaSpravaSearch {
  const raw = input.nastroj;
  return raw === 'tarify' || raw === 'pojistovny' || raw === 'brana' || raw === 'vyjimky' || raw === 'nastaveni' || raw === 'historie' ? { nastroj: raw } : {};
}

/** The `/pujcovna/vozidla/nove` search: a VIN to pre-select (from "Zařadit do půjčovny" on a car's detail). */
export interface FleetEnrollSearch {
  vin?: string;
}

export function parseFleetEnrollSearch(input: Record<string, unknown>): FleetEnrollSearch {
  const raw = input.vin;
  return typeof raw === 'string' && raw.trim() !== '' ? { vin: raw.trim().slice(0, 64) } : {};
}

/** Czech wording of the fleet entry's link state (`stav_vazby`); anything but `ok` serves no car data. */
export function stavVazbyText(stav: 'ok' | 'nejasny' | 'zastarala'): string {
  if (stav === 'nejasny') return 'Duplicitní VIN — vyřešte převodem nebo úklidem v kartotéce.';
  if (stav === 'zastarala') return 'Záznam vozidla už není aktuální — vyřaďte vůz z půjčovny a zařaďte ho znovu.';
  return '';
}

const normVin = (vin: string) => vin.replace(/\s+/g, '').toUpperCase();

/** The firma's fleet entry for a car, found by VIN (whitespace- and case-insensitive); none without a VIN. */
export function fleetEntryForVin<T extends { vin: string }>(entries: readonly T[] | undefined, vin: string | null | undefined): T | undefined {
  const key = normVin(vin ?? '');
  if (!key) return undefined;
  return entries?.find((e) => normVin(e.vin) === key);
}

/** The turnaround gap's bounds (the API's `NastaveniBodySchema`): whole days, 0 = the day after a return. */
export const MEZERA_MAX = 30;

/** The typed gap as a whole number of days, or null when it is not one in range (an empty box is not 0). */
export function parseMezera(input: string): number | null {
  const t = input.trim();
  if (!/^\d{1,2}$/.test(t)) return null;
  const n = Number(t);
  return n >= 0 && n <= MEZERA_MAX ? n : null;
}
